import React, { FC } from 'react';

import { Icon } from './styles';

const HandleIcon: FC = ({ children, ...props }) => {
  return <Icon {...props} />;
};

export default HandleIcon;
